import { MenuItem } from '@core/models';

export function calculateCartItemQuantity(
	items: MenuItem[] | null | undefined,
	idArticulo: string
): number {
	return (items ?? [])
		.filter(item => item.idArticulo === idArticulo)
		.reduce((total, item) => total + Number(item.cantidad ?? 0n), 0);
}
